<template>
  <div style="clear: both;">
    <v-text-field label :model-value="modelValue" variant="underlined" :readonly="readonly" density="comfortable"></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped></style>
